import {Api} from './config/request';

const getAllTestsReq = (crmLsqId) => (Api.getFliveRequest(`test/${crmLsqId}`, true));
const updateTestReport = (updateReportObj) => (Api.postFliveRequest(`report/insert`, updateReportObj,true));

export const TestApiCalls = {
    getAllTestsReq,
    updateTestReport
}
